import { useAuthStore } from '@/stores/auth';

function getTransactionQuery(queryString) {
    queryString = encodeURI(queryString.split(' ').filter(Boolean).join('+'));

    return 'Organization/$lookup?by=name,identifier.value;address.city,address.line;telecom.value&sort=name&count=50&q=' + queryString + '&careTeamOnly=false';
}

function processOrganizationResponse(organizations) {
    const authStore = useAuthStore();
    const authAccoutId = authStore.account.id;

    // TODO: Change when AidBox LookUp function is updated to allow filtering
    return organizations.filter((organization) => organization.id !== authAccoutId && (!organization.partOf || organization.partOf.id !== authAccoutId) && organization.careTeamOnly !== true);
}

export default {
    getTransactionQuery: getTransactionQuery,
    processOrganizationResponse: processOrganizationResponse,
};
